<!--
@Author: Colin Osterhout <ctosterhout>
@Date:   2019-02-07T09:10:31-09:00
@Email:  ctosterhout@alaska.edu
@Last modified by:   ctosterhout
@Last modified time: 2020-01-20T14:23:54-09:00
@License: Released under MIT License. copyright 2019 University of Alaska Southeast.  For more details, see https://opensource.org/licenses/MIT
-->

<template>
  <div class="page-header-logo-mobile text-center">
    <a :href="baseUrl">
      <img :src="`${cdnBase}/static/images/uas-logo-text-only-reverse.svg`"
           class="logo-horizontal"
           alt="University of Alaska Southeast Horizontal Logo">
    </a>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../scss/modules/bootstrap-extend';
@import '../scss/modules/variables';
@import '../scss/modules/palette';
@import '~ernie-core/scss/palette';

$color-general-blue: #004A7F;
$color-logo-blue-light: #059AC7;
$height-page-header-logo-mobile: 30px;

.page-header-logo-mobile {
    width: 100%;
    height: $height-page-header-logo-mobile;
    background-color: $color-logo-blue-light;
}

.logo-horizontal {
    height: 30px;
    padding: 3px;
}

</style>

<script>

export default {
  name: '',
  props: {},
  data: function () {
    return {
      baseUrl: '//uas.alaska.edu/',
      cdnBase: process.env.VUE_APP_CDN_BASE
    }
  },
  methods: {},
  components: {}
}
</script>
